import React from "react";
import BlockContainer from "./BlockContainer";
import BoardAnimation from "./BoardAnimation2";
import styles from './PageFive.module.scss';
import TitleContainer from "./TitleContainer";

export default function PageFive() {

    return (
        <div className={styles["container"]} id="pageFive">
            <BlockContainer />
            <div className={styles["main-container"]}>
                <TitleContainer file={"./assets/page_52/5_title.png"} />
                <div className={styles["board-container"]}>
                    <BoardAnimation />
                </div>
            </div>
        </div>
    )
}
